/* eslint-disable no-invalid-this */
/* eslint-disable require-jsdoc */
import React, { PureComponent } from 'react';
import { ControlSpeed, ControlType } from '../../util';
import './index.scss';
interface SpeedDashboardProps {
  onChange: AnyFunc;
  maxLimit: number;
  visible: boolean;
  realtimeSpeed?: number;
}

const btnGroup = [
  {
    cls: 'slow-down-btn',
    speedType: ControlSpeed.SLOW_DOWN,
  },
  {
    cls: 'speed-up-btn',
    speedType: ControlSpeed.SPEED_UP,
  },
  {
    cls: 'brake-btn',
    speedType: ControlSpeed.BRAKE,
  },
];

class SpeedDashboard extends PureComponent<SpeedDashboardProps, any> {
  constructor(props: SpeedDashboardProps) {
    super(props);
    this.state = {
      speed: 0,
    };
  }

  handleChange = (
    speedType: ControlSpeed,
    trigger: 'click' | 'keyboard' = 'click',
    key?: string,
  ) => {
    const { maxLimit } = this.props;
    let realSpeed: any = this.state.speed;
    if (speedType === ControlSpeed.SLOW_DOWN) {
      if (realSpeed !== 0) {
        realSpeed -= 0.1;
      }
    } else if (speedType === ControlSpeed.SPEED_UP) {
      if (realSpeed < maxLimit) {
        realSpeed += 0.1;
      }
    } else if (speedType === ControlSpeed.BRAKE) {
      realSpeed = 0;
    }
    realSpeed = parseFloat(realSpeed.toFixed(1));

    this.setState(
      {
        speed: realSpeed,
      },
      () => {
        this.props.onChange &&
          this.props.onChange(
            ControlType.SPEED,
            realSpeed,
            speedType,
            trigger,
            key,
          );
      },
    );
  };

  resetSpeed = () => {
    this.setState({
      speed: 0,
    });
  };

  handleDealWithKeyboardEventCode = (event: any) => {
    const keyCode = event.code;
    switch (keyCode) {
      case 'ArrowDown':
        this.handleChange(ControlSpeed.SLOW_DOWN, 'keyboard', keyCode);
        break;
      case 'ArrowUp':
        this.handleChange(ControlSpeed.SPEED_UP, 'keyboard', keyCode);
        break;
      case 'Space':
        this.handleChange(ControlSpeed.BRAKE, 'keyboard', keyCode);
        break;
      default:
        return;
    }
  };

  componentDidUpdate(
    prevProps: Readonly<SpeedDashboardProps>,
    prevState: Readonly<any>,
    snapshot?: any,
  ): void {
    if (prevProps.visible !== this.props.visible) {
      if (prevProps.visible) {
        document.addEventListener(
          'keyup',
          this.handleDealWithKeyboardEventCode,
        );
      } else {
        document.removeEventListener(
          'keyup',
          this.handleDealWithKeyboardEventCode,
        );
      }
    }
  }

  componentDidMount() {
    document.addEventListener('keyup', this.handleDealWithKeyboardEventCode);
  }

  componentWillUnmount() {
    document.removeEventListener('keyup', this.handleDealWithKeyboardEventCode);
  }

  render() {
    const { realtimeSpeed = 0 } = this.props;
    const { speed } = this.state;
    const targetSpeedPointerRotateStyle = {
      transform: `rotate(${this.state.speed * 10 * 14.75}deg)`,
    };

    const realtimeSpeedRotateStyle = {
      transform: `rotate(${realtimeSpeed * 10 * 14.75}deg)`,
    };
    return (
      <div className='speed-dashboard'>
        <i className='speed-dashboard-icon'></i>
        <div className='speed-direction'>
          <div className='board-title'>速度</div>
          <div className='center-box'>
            <div className='realtime-speed'>
              <span>实时</span>
              <span>
                {(realtimeSpeed &&
                  Math.abs(parseFloat(realtimeSpeed.toFixed(2)))) ||
                  0}
              </span>
            </div>
            <div className='target-speed'>
              <span>目标</span>
              <span>{speed}</span>
            </div>
          </div>
        </div>
        <div className='speed-pointer'>
          <i
            className='target-speed-pointer'
            style={targetSpeedPointerRotateStyle}
          />
          <i
            className='realtime-speed-pointer'
            style={realtimeSpeedRotateStyle}
          />
        </div>
        <div className='control-btn-group'>
          {btnGroup.map((item: any, index: number) => (
            <i
              key={index}
              className={item.cls}
              onClick={() => this.handleChange(item.speedType)}
            />
          ))}
        </div>
      </div>
    );
  }
}

export default SpeedDashboard;
